/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_Settings_FileInputs */



/**
* | output |
* | --- |
* | "Choose Settings File" |
*
* @param {Choose_Settings_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const choose_settings_file = /** @type {((inputs?: Choose_Settings_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_Settings_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisir le fichier de paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungsdatei auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli il file delle impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите файл настроек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar archivo de configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择设置文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定ファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o arquivo de configurações.")
	return /** @type {LocalizedString} */ ("Choose Settings File")
});